import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "px-5",
  style: {"max-height":"900px","overflow-y":"auto"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "dialog-footer" }

import { ref, computed } from "vue";
import SelectEventType from "./SelectEventType.vue";
import CreateNormalEvent from "./create/CreateNormalEvent.vue";
import CreatePopupEvent from "./create/CreatePopupEvent.vue";
import CreateHeaderEvent from "./create/CreateHeaderEvent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventV2',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {



const modalRef = ref(false);
const step = ref(0);
const selectedType = ref(0);
const normalRef = ref<InstanceType<typeof CreateNormalEvent>>();
const popupRef = ref<InstanceType<typeof CreatePopupEvent>>();
const headerRef = ref<InstanceType<typeof CreateHeaderEvent>>();

// Normal = 4 steps (0~3), Popup/Header = 3 steps (0~2)
const maxStep = computed(() => (selectedType.value === 0 ? 3 : 2));

const isSubmitting = computed(() => {
  if (selectedType.value === 0) return normalRef.value?.isSubmitting ?? false;
  if (selectedType.value === 1) return popupRef.value?.isSubmitting ?? false;
  return headerRef.value?.isSubmitting ?? false;
});

const show = () => {
  modalRef.value = true;
};

const hide = () => {
  modalRef.value = false;
  step.value = 0;
  selectedType.value = 0;
  normalRef.value?.reset();
  popupRef.value?.reset();
  headerRef.value?.reset();
};

const triggerSubmit = () => {
  if (selectedType.value === 0) normalRef.value?.submit();
  else if (selectedType.value === 1) popupRef.value?.submit();
  else headerRef.value?.submit();
};

const onChildSubmit = () => {
  emits("submit");
  hide();
};

__expose({ show, hide });

return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: modalRef.value,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalRef).value = $event)),
    title: _ctx.$t('action.addEvent'),
    "before-close": hide,
    class: "w-1000px",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        (step.value === 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_button, { onClick: hide }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (step.value++))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.next")), 1)
                ]),
                _: 1
              })
            ], 64))
          : (step.value < maxStep.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_button, {
                  disabled: isSubmitting.value,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (step.value--))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.back")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  disabled: isSubmitting.value,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (step.value++))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.next")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_el_button, {
                  disabled: isSubmitting.value,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (step.value--))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.back")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: isSubmitting.value,
                  onClick: triggerSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 64))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_steps, {
          active: step.value,
          "finish-status": "success",
          class: "mb-5",
          style: {"max-width":"800px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_step, {
              title: _ctx.$t('fields.eventType')
            }, null, 8, ["title"]),
            _createVNode(_component_el_step, {
              title: _ctx.$t('fields.basicInfo')
            }, null, 8, ["title"]),
            _createVNode(_component_el_step, {
              title: _ctx.$t('fields.content')
            }, null, 8, ["title"]),
            (selectedType.value === 0)
              ? (_openBlock(), _createBlock(_component_el_step, {
                  key: 0,
                  title: _ctx.$t('fields.pointsRules')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["active"]),
        (step.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(SelectEventType, {
                modelValue: selectedType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedType).value = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (selectedType.value === 0)
          ? _withDirectives((_openBlock(), _createBlock(CreateNormalEvent, {
              key: 1,
              ref_key: "normalRef",
              ref: normalRef,
              step: step.value,
              onSubmit: onChildSubmit
            }, null, 8, ["step"])), [
              [_vShow, step.value > 0]
            ])
          : _createCommentVNode("", true),
        (selectedType.value === 1)
          ? _withDirectives((_openBlock(), _createBlock(CreatePopupEvent, {
              key: 2,
              ref_key: "popupRef",
              ref: popupRef,
              step: step.value,
              onSubmit: onChildSubmit
            }, null, 8, ["step"])), [
              [_vShow, step.value > 0]
            ])
          : _createCommentVNode("", true),
        (selectedType.value === 2)
          ? _withDirectives((_openBlock(), _createBlock(CreateHeaderEvent, {
              key: 3,
              ref_key: "headerRef",
              ref: headerRef,
              step: step.value,
              onSubmit: onChildSubmit
            }, null, 8, ["step"])), [
              [_vShow, step.value > 0]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})